import { buildTScoped } from 'helpers/translationHelpers';
import { useEffect, useState } from 'react';
import { MANTY_STATUS } from 'routes/HumanResourcesModule/business/definitions';
import { DateString } from 'routes/HumanResourcesModule/business/types';
import { orgChartHrFormatter } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import {
    getPositionValue,
    PositionMappingValue,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
const tScoped = buildTScoped(
    'humanResources.simulation.envelope.creationModal',
);
export const getModalTitle = (
    mantyStatus: MantyStatus | null,
    orgChartHrName: string,
    orgChartHrMapping: string,
) =>
    tScoped(`mantyStatus.title`, {
        [MANTY_STATUS]: getPositionValue(
            mantyStatus as PositionMappingValue,
            true,
        ).toLowerCase(),
        orgChartHr: orgChartHrFormatter({
            orgChartHrName,
            orgChartHrMapping,
        }),
    });
export type FormState = {
    mantyStatus: MantyStatus | null;
    comment: string;
    valuesByDates: Record<DateString, number>;
    selectedOrgChartHrsSoftwareId: string;
    isFormValid: boolean;
    hasChanges: boolean;
};

export function useFormState(
    initialState: FormState,
): [FormState, React.Dispatch<React.SetStateAction<FormState>>] {
    const [state, setState] = useState(initialState);
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        if (state.mantyStatus && state.selectedOrgChartHrsSoftwareId)
            setIsFormValid(true);
    }, [state.mantyStatus, state.selectedOrgChartHrsSoftwareId]);

    return [{ ...state, isFormValid }, setState];
}
